import { render, staticRenderFns } from "./KnihaJizd.vue?vue&type=template&id=d724978c&"
import script from "./KnihaJizd.vue?vue&type=script&lang=ts&"
export * from "./KnihaJizd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports